/* FGR4 V4 / 07 — lightweight editorial interaction. No product-form, cart or header interference. */
(function(){
'use strict';
function initHero(stage){
 if(stage.dataset.f7Ready==='1')return;stage.dataset.f7Ready='1';
 if(!window.matchMedia('(hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference)').matches)return;
 var visual=stage.querySelector('.f4-stage__visual');if(!visual)return;
 var busy=false,x=0,y=0;
 visual.addEventListener('pointermove',function(e){
  var rect=visual.getBoundingClientRect();
  x=Math.max(-1,Math.min(1,((e.clientX-rect.left)/rect.width-.5)*2));
  y=Math.max(-1,Math.min(1,((e.clientY-rect.top)/rect.height-.5)*2));
  if(busy)return;busy=true;
  requestAnimationFrame(function(){busy=false;stage.style.setProperty('--f7-mx',x.toFixed(3));stage.style.setProperty('--f7-my',y.toFixed(3));});
 },{passive:true});
 visual.addEventListener('pointerleave',function(){stage.style.setProperty('--f7-mx','0');stage.style.setProperty('--f7-my','0');},{passive:true});
}
function initReading(root){
 if(root.dataset.f7ReadingReady==='1')return;root.dataset.f7ReadingReady='1';
 var bar=root.querySelector('[data-f7-reading-fill]');var doc=root.querySelector('[data-f7-document-body]');if(!bar||!doc)return;
 var scheduled=false;
 function update(){
  scheduled=false;
  var bounds=doc.getBoundingClientRect(),distance=Math.max(doc.offsetHeight-window.innerHeight*.55,1);
  var progress=Math.max(0,Math.min(1,(-bounds.top+window.innerHeight*.28)/distance));
  bar.style.transform='scaleX('+progress.toFixed(4)+')';
 }
 function request(){if(scheduled)return;scheduled=true;requestAnimationFrame(update);}
 window.addEventListener('scroll',request,{passive:true});window.addEventListener('resize',request,{passive:true});
 request();
}
function init(){
 document.querySelectorAll('.f7-stage').forEach(initHero);
 document.querySelectorAll('[data-f7-reading]').forEach(initReading);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();